import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installFetchInterceptor } from './lib/fetchInterceptor';
import { reportClientError } from './services/ErrorReportingService';

const isStagingHost = window.location.hostname.includes('staging');
const isProductionRuntime = import.meta.env.PROD && !isStagingHost;

if (isProductionRuntime) {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
}

// Install global fetch interceptor to attach JWT to all /api/ requests
installFetchInterceptor();

window.addEventListener('error', (event) => {
  const error = event.error as Error | undefined;
  reportClientError({
    message: error?.message || event.message || 'Unhandled window error',
    stack: error?.stack,
    source: 'window.error',
    metadata: {
      filename: event.filename,
      line: event.lineno,
      column: event.colno,
    },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as Error | string | undefined;
  reportClientError({
    message: typeof reason === 'string' ? reason : reason?.message || 'Unhandled promise rejection',
    stack: typeof reason === 'object' ? reason?.stack : undefined,
    source: 'window.unhandledrejection',
    metadata: {
      reasonType: typeof reason,
    },
  });
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
